<!-- MODULO BANNER -->
<div class="container-fluid cta mb-5">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-md-10 mb-4 mb-md-0">
        <h5 class="text-white">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In gravida neque in lacus laoreet
        </h5>
      </div>
      <div class="col-12 col-md-2 text-center">
         <button class="btn btn-stem mx-auto" type="button">
            Configurer votre produit
          </button>
      </div>
    </div>
    
  </div>
</div>
<!-- //MODULO BANNER -->